import { defineComponent } from "vue";
import common from "../core/core";
import { VueAutoHeight } from "@/core/vue-auto-height.component";
import { Navigation, Pagination, Swiper as SwiperCreator } from "swiper";

export default defineComponent({
  components: {
    VueAutoHeight,
  },
  data() {
    return {
      reviewsSwiper: null,
    };
  },
  mounted() {
    this.reviewsSwiper = new SwiperCreator(this.$refs.reviewsSwiper as HTMLElement, {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".to-right",
        prevEl: ".to-left",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
      // autoHeight: true,
      slidesPerView: "auto",
      allowTouchMove: true,
    });
  },
  computed: {},
  methods: {},
  mixins: [common],
});
